import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
let SortDropdownComponent = class SortDropdownComponent extends Vue {
    options;
    value;
    defaultValue;
    onValueChange(newValue, oldValue) {
        if (newValue.sortBy === oldValue.sortBy && newValue.sortOrder === oldValue.sortOrder)
            return;
        this.$emit('input', newValue);
    }
    clearSort() {
        this.$emit('input', this.defaultValue);
    }
    setSortBy(sortBy) {
        this.$emit('input', { sortBy, sortOrder: this.value.sortOrder });
    }
    setSortOrder(sortOrder) {
        this.$emit('input', { sortBy: this.value.sortBy, sortOrder });
    }
};
__decorate([
    Prop({ type: Array, required: true })
], SortDropdownComponent.prototype, "options", void 0);
__decorate([
    Prop({ type: Object, default: {} })
], SortDropdownComponent.prototype, "value", void 0);
__decorate([
    Prop({ type: Object, default: () => ({ sortBy: '', sortOrder: 'ascending' }) })
], SortDropdownComponent.prototype, "defaultValue", void 0);
__decorate([
    Watch('value')
], SortDropdownComponent.prototype, "onValueChange", null);
SortDropdownComponent = __decorate([
    Component({})
], SortDropdownComponent);
export default SortDropdownComponent;
